import React, { useState, useEffect } from "react";
import "./style/CreativeStyle.css";
import EmojiPicker from "emoji-picker-react";
import { Campaign } from "@mui/icons-material";
import { FaEye } from "react-icons/fa"; // Import eye icon from react-icons


interface FormData {
  adName: string;
  title: string;
  description1: string;
  description2: string;
  displayURL: string;
  destinationURL: string;
  trafficSourceType: string;
  frequencyFilter: string;
  imgLocation: string;
}




interface StepProps {
  recordId: number;
  handleClose: () => void;
  onUpdate: () => void;
}



const CreativeStepPopup2: React.FC<StepProps> = ({
  recordId,
  handleClose,
  onUpdate,
}) => {
  const [formData, setFormData] = useState<FormData>({
    adName: "",
    title: "",
    description1: "",
    description2: "",
    displayURL: "",
    destinationURL: "",
    trafficSourceType: "",
    frequencyFilter: "",
    imgLocation: "",
  });



  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const openLink = () => {
    if (formData.destinationURL.startsWith("http")) {
      window.open(formData.destinationURL, "_blank"); // Open link in a new tab
    } else {
      alert("Invalid URL. Ensure it starts with http");
    }
  };

  useEffect(() => {
    console.log("Fetching record for ID:", recordId); // Debug log

    const fetchData = async () => {
      if (!recordId) {
        console.error("No recordId provided");
        return;
      }

      try {
        const baseUrl = window.location.hostname === "localhost"
          ? `http://localhost:5000/api/creatives/getCreativeById/${recordId}`
          : `https://bidvertiser-api.vercel.app/api/creatives/getCreativeById/${recordId}`;

        const response = await fetch(baseUrl);
        if (!response.ok) {
          throw new Error(`Failed to fetch data: ${response.statusText}`);
        }
        const data = await response.json();

        setFormData({
          adName: data.ad_name || "",
          title: data.title || "",
          description1: data.description_1 || "",
          description2: data.description_2 || "",
          displayURL: data.display_url || "",
          destinationURL: data.destination_url || "",
          trafficSourceType: data.traffic_source_type || "",
          frequencyFilter: data.frequency_filter || "",
          imgLocation: data.img_location || "", // Set image location directly
        });
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, [recordId]);





  const [pickerState, setPickerState] = useState<{
    title: boolean;
    description1: boolean;
    description2: boolean;
  }>({
    title: false,
    description1: false,
    description2: false,
  });


  const handleInputChange = (

    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev: FormData) => ({ ...prev, [name]: value }));

  };

  const handleUpdate = async () => {
    if (!recordId) {
      console.error("No record ID provided");
      return;
    }

    console.log("Updating record with ID:", recordId);

    setLoading(true);
    setError(null);

    try {
      // Convert formData state into a JSON object
      const updatedData = {
        adName: formData.adName,
        title: formData.title,
        description1: formData.description1,
        description2: formData.description2,
        displayURL: formData.displayURL,
        destinationURL: formData.destinationURL,
        imgLocation: formData.imgLocation, // Ensure image URL is passed correctly
      };

      // Determine base URL based on environment
      const baseUrl =
        window.location.hostname === "localhost"
          ? `http://localhost:5000/api/creatives/updateCreative/${recordId}`
          : `https://bidvertiser-api.vercel.app/api/creatives/updateCreative/${recordId}`;

      const response = await fetch(baseUrl, {
        method: "PUT", // Match the API's method
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedData), // Send data as JSON
      });

      if (!response.ok) {
        throw new Error(`Failed to update record: ${response.status} ${response.statusText}`);
      }

      const responseData = await response.json();
      alert("Record updated successfully!");

      onUpdate(); // Refresh parent data
      handleClose(); // Close the popup

      return responseData;
    } catch (err: any) {
      console.error("Error updating record:", err);
      setError(err.message || "An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };




  const handleEmojiClick = (
    emojiData: { emoji: string },
    field: "title" | "description1" | "description2"
  ) => {
    const updatedValue = formData[field] + emojiData.emoji;
    handleInputChange({
      target: {
        name: field,
        value: updatedValue,
      },
    } as React.ChangeEvent<HTMLInputElement>);
    setPickerState((prev) => ({ ...prev, [field]: false })); // Close picker after selection
  };

  const togglePicker = (field: "title" | "description1" | "description2") => {
    setPickerState((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      const imageName = file.name; // Extract file name
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result as string);
      };
      reader.readAsDataURL(file);

      setFormData((prev: any) => ({ ...prev, imgLocation: imageName }));

      // ✅ Call handleImageChange and pass the event
      handleImageChange(e);
    }
  };

  const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        // Determine base URL for API request
        const baseUrl =
          window.location.hostname === "localhost"
            ? "http://localhost:5000/api/campaigns/upload"
            : "https://bidvertiser-api.vercel.app/api/campaigns/upload";

        const response = await fetch(baseUrl, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();
        if (response.ok) {
          setFormData((prev: any) => ({
            ...prev,
            imgLocation: data.fileUrl, // ✅ Store actual image URL
          }));
          setImagePreview(URL.createObjectURL(file)); // Show preview
        } else {
          console.error("Upload failed:", data.message);
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };


  if (loading) return <div>Loading...</div>;

  return (
    <div className="MainSection">
      <div style={{ height: '50px', backgroundColor: '#1B3A5E', padding: '0.1px 0 1px 6px' }}>
        <h3 style={{ color: 'white', fontWeight: '400' }}>Edit Ad</h3>
      </div>
      <div className="CreativePara">
        <div style={{ fontSize: '15px', fontWeight: '500', marginTop: '10px', fontFamily: "'Open Sans', sans-serif" }}>
          Campaign: {formData.title}
        </div>

        <p>
          Use the form below to name your ad, choosing its type, entering a title, two lines of
          description, and a URL.
        </p>
        <h1 style={{ fontSize: "13px", fontWeight: '600', marginBottom: '-10px' }}>Landing Page Guidance:</h1>
        <p>
          No malicious, malware, flash updates, fake virus warnings, auto downloads, scareware, or
          tech support.
          <br />
          These restrictions also apply to affiliate smartlinks, so make sure that your provider
          excludes such offers.
          <br />
          Failure to do so may lead to account suspension.
        </p>
      </div>
      <div className="FormSection">
        <form className="FormCreative">
          <div
            className="labelCreative"
            style={{
              border: "solid",
              borderWidth: "0 0 1px 0",
              padding: "12px 0px",
              borderColor: "#888",
            }}>
            <label className="labelHeading">Name your Ad:</label> <br />
            <input
              style={{
                color: 'rgb(109, 108, 108)',
                padding: '6px',
              }}
              type="text"
              name="adName"
              maxLength={25}
              value={formData.adName}
              onChange={handleInputChange}
            />
            <span style={{ fontSize: "12px", color: "#888", margin: "0 5px" }}>
              {formData.adName.length}/25
            </span>
            <small style={{ color: "#888" }}>(Won't be seen by web visitors)</small>
          </div>

          <div style={{ gap: '200px', display: 'flex', borderWidth: '0px 0px 1px 0px', border: 'none', borderColor: '#888', padding: '0 0 20px 0' }}>

            <div style={{ marginRight: '-100px' }}>
              <div style={{ position: "relative", margin: "10px 0px 5px 0px", width: "400px" }}>
                <label className="labelHeading">Title:</label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "4px 3px",
                  }}
                >
                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    placeholder="Ad title"
                    maxLength={25}
                    style={{
                      border: "none",
                      color: 'rgb(109, 108, 108)',
                      outline: "none",
                      flex: 1,
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => togglePicker("title")}

                    style={{
                      borderTopWidth: ' 0',
                      borderRightWidth: "0",
                      borderBottomWidth: "0",
                      borderLeftWidth: '1px',
                      borderColor: '#888',
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "16px",
                      marginLeft: "8px",
                    }}
                  >
                    <span><svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="#5D86C9" stroke-width="2" fill="none" />
                      <circle cx="9" cy="10" r="1.5" fill="#5D86C9" />
                      <circle cx="15" cy="10" r="1.5" fill="#5D86C9" />
                      <path d="M8 15C9 16 11 17 13 16C14.5 15.5 15 15 16 14" stroke="#5D86C9" stroke-width="2" stroke-linecap="round" />
                    </svg>
                    </span>

                  </button>
                  {pickerState.title && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: "0",
                        zIndex: 1000,
                      }}
                    >
                      <EmojiPicker
                        onEmojiClick={(emojiData) =>
                          handleEmojiClick(emojiData, "title")
                        }
                      />
                    </div>
                  )}
                  <div style={{ fontSize: "12px", color: "#888" }}>{formData.title.length}/25</div>
                </div>

              </div>


              <div style={{ position: "relative", margin: "10px 0px 5px 0px", width: "400px" }}>
                <label className="labelHeading">Description line 1:</label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "8px",
                  }}
                >
                  <input
                    type="text"
                    name="description1"
                    value={formData.description1}
                    maxLength={35}
                    onChange={handleInputChange}
                    placeholder="First line of description"
                    style={{
                      color: 'rgb(109, 108, 108)',
                      border: "none",
                      outline: "none",
                      flex: 1,
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => togglePicker("description1")}
                    style={{
                      background: "none",
                      border: "none",
                      borderTopWidth: ' 0',
                      borderRightWidth: "0",
                      borderBottomWidth: "0",
                      borderLeftWidth: '1px',
                      borderColor: '#888',
                      cursor: "pointer",
                      fontSize: "16px",
                      marginLeft: "8px",
                    }}
                  >
                    <span><svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="#5D86C9" stroke-width="2" fill="none" />
                      <circle cx="9" cy="10" r="1.5" fill="#5D86C9" />
                      <circle cx="15" cy="10" r="1.5" fill="#5D86C9" />
                      <path d="M8 15C9 16 11 17 13 16C14.5 15.5 15 15 16 14" stroke="#5D86C9" stroke-width="2" stroke-linecap="round" />
                    </svg>
                    </span>
                  </button>
                  {pickerState.description1 && (
                    <div
                      style={{
                        position: "absolute",
                        color: 'rgb(109, 108, 108)',
                        top: "100%",
                        right: "0",
                        zIndex: 1000,
                      }}
                    >
                      <EmojiPicker
                        onEmojiClick={(emojiData) =>
                          handleEmojiClick(emojiData, "description1")
                        }
                      />
                    </div>
                  )}
                  <div style={{ fontSize: "12px", color: "#888" }}>{formData.description1.length}/35</div>
                </div>

              </div>


              <div style={{ position: "relative", margin: "10px 0px 5px 0px", width: "400px" }}>
                <label className="labelHeading">Description line 2:</label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "8px",
                  }}
                >
                  <input
                    type="text"
                    name="description2"
                    value={formData.description2}
                    maxLength={35}
                    onChange={handleInputChange}
                    placeholder="First line of description"
                    style={{
                      border: "none",
                      outline: "none",
                      color: 'rgb(109, 108, 108)',
                      flex: 1,
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => togglePicker("description2")}
                    style={{
                      borderTopWidth: ' 0',
                      borderRightWidth: "0",
                      borderBottomWidth: "0",
                      borderLeftWidth: '1px',
                      borderColor: '#888',
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "16px",
                      marginLeft: "8px",
                    }}
                  >
                    <span><svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="#5D86C9" stroke-width="2" fill="none" />
                      <circle cx="9" cy="10" r="1.5" fill="#5D86C9" />
                      <circle cx="15" cy="10" r="1.5" fill="#5D86C9" />
                      <path d="M8 15C9 16 11 17 13 16C14.5 15.5 15 15 16 14" stroke="#5D86C9" stroke-width="2" stroke-linecap="round" />
                    </svg>
                    </span>
                  </button>
                  {pickerState.description2 && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: "0",
                        zIndex: 1000,
                        color: 'rgb(109, 108, 108)',

                      }}
                    >
                      <EmojiPicker
                        onEmojiClick={(emojiData) =>
                          handleEmojiClick(emojiData, "description2")
                        }
                      />                    </div>
                  )}
                  <div style={{ fontSize: "12px", color: "#888" }}>{formData.description2.length}/35</div>
                </div>

              </div>




              <div style={{ position: "relative", margin: "10px 0px 5px 0px", width: "400px" }}>
                <label className="labelHeading">Display URL : <i className="fa fa-info-circle"></i>
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "8px",
                  }}
                >
                  <input
                    type="text"
                    name="displayURL"
                    value={formData.displayURL}
                    maxLength={35}
                    onChange={handleInputChange}
                    placeholder="www.yourwebsitename.com"
                    style={{
                      border: "none",
                      outline: "none",
                      flex: 1,
                      color: 'rgb(109, 108, 108)',

                    }}
                  />

                  <div style={{ fontSize: "12px", color: "#888" }}>{formData.displayURL.length}/35</div>
                </div>

              </div>
            </div>




            <div  style={{ maxWidth: '25%', marginTop: "20px", height: '14%' }}>
                <p>Ad Preview: ( with Macros replacement <i className="fa fa-info-circle"></i> )</p>
                <div style={{padding: "0px", border: "1px solid #ccc"}}>

              
              {formData.imgLocation && (
                <img src={`${formData.imgLocation}`} alt="Uploaded Image" style={{ width: "100%" }} />
              )}

              <div style={{ backgroundColor: '#FFFFFF', gap: '0px', rowGap: '0px' }}>
                <p style={{ marginTop: '-6px', fontWeight: "bold", fontSize: "14px" }}>{formData.title || "Ad Title"}</p>
                <p style={{ marginTop: '-15px' }}>{formData.description1 || "First line of description"}</p>
                <p style={{ marginTop: '-15px' }}>{formData.description2 || "Second line of description"}</p>
                <p style={{ color: "#888", marginTop: '-15px' }}>{formData.displayURL || "www.yourwebsitename.com"}</p>

              </div>
              </div>
            </div>


          </div>


          <hr style={{ color: "#888" }}></hr>



          <div style={{ position: "relative", margin: "10px 0px 5px 0px", width: "90%" }}>
      <label className="labelHeading">
        Destination URL / Tel: <i className="fa fa-info-circle"></i>
      </label>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "8px",
        }}
      >
        <input
          type="text"
          name="destinationURL"
          value={formData.destinationURL}
        
          onChange={handleInputChange}
          placeholder="http://yourwebsite.com"
          style={{
            border: "none",
            outline: "none",
            flex: 1,
            color: 'rgb(109, 108, 108)',

          }}
        />
        <FaEye
          onClick={openLink}
          style={{
            cursor: "pointer",
            color: "#007bff",
            fontSize: "20px",
            marginLeft: "10px",
          }}
          title="Open URL"
        />
      </div>
    </div>

          <hr style={{ marginTop: '30px', color: "#888", fontSize: '12px' }}></hr>

          <div style={{ display: 'flex', marginTop: '30px', gap: '100px', fontSize: '12px' }}>
            <label>Traffic Source Type:  <i className="fa fa-info-circle"></i>
            </label>
            <div >
              <label style={{ marginRight: '50px' }}>
                <input
                  type="radio"
                  name="trafficSourceType"
                  value="Mainstream"
                  checked={formData.trafficSourceType === "Mainstream"}
                  onChange={handleInputChange}
                />
                Mainstream
              </label>
              <label style={{ marginRight: '50px' }}>
                <input
                  type="radio"
                  name="trafficSourceType"
                  value="Porn"
                  checked={formData.trafficSourceType === "Porn"}
                  onChange={handleInputChange}
                />
                Porn
              </label>


            </div>
            <p style={{ color: '#888', marginTop: '0px' }}>
              (Adult campaigns must use "Porn" traffic source type)
            </p>
          </div>


          <hr style={{ marginTop: '20px', color: "#888" }}></hr>

          <div style={{ lineHeight: '10px' }}>
            <p> <b>Optional: </b> Upload an image in a format of GIF / JPG / JPEG / PNG [recommended image size: 300 x 200]
              <br></br>
              •  You can crop your image to the correct size on the next page <br></br>
              •  Maximum file size to upload for cropping is 2MB</p>

            <div style={{ display: 'flex' }}>
              <label
                htmlFor="imageInput"
                style={{
                  display: 'inline-block',
                  padding: '10px 20px',
                  backgroundColor: '#1B3A5E',
                  color: '#fff',
                  cursor: 'pointer',
                  fontSize: '16px',
                  textAlign: 'center',
                }}
              >
                Choose an Image
              </label>
              <input
                id="imageInput"
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                style={{ display: 'none' }}
              />
            </div>
          </div>



          {/* <hr style={{ marginTop: '20px', color: "#888" }}></hr> */}



          {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
          {/*  ImFilter section start here  | */}
          {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}


          <div style={{ fontSize: '12px' }}>
            <label >Frequency Filter:</label> <i className="fa fa-info-circle"></i> <br></br>
            <select
              style={{ marginTop: '10px', width: '150px', height: '35px', padding: '10px' }}
              name="frequencyFilter"
              value={formData.frequencyFilter}
              onChange={handleInputChange}
            >
              <option value="8 Hours">8 Hours</option>
              <option value="24 Hours">24 Hours</option>
              <option value="No Limit">No Limit</option>
            </select>
            <small style={{ marginLeft: '14px' }}>
              Your campaign will receive the same visitor no more than once per selected time.
            </small>
          </div>



          <hr style={{ marginTop: '20px', color: "#888" }}></hr>


<div style={{alignItems:'center'}}>
<button style={{ padding: '10px', backgroundColor: '#1A3F66', color: 'white', borderRadius: "2px", paddingLeft: '30px', paddingRight: '30px' }} type="button" onClick={handleUpdate}>
            Update
          </button>
</div>
          


          <p></p>
        </form>
      </div>
      {error && <div style={{ color: "red" }}>Error: {error}</div>}

    </div>
  );
};

export default CreativeStepPopup2;
